export default __webpack_public_path__ + "static/media/cesto_fragole.456fc876.svg";